import { Component, computed, OnInit, inject } from '@angular/core';
import { CardsWidgetMapped } from '../../../../../_interfaces/dashboard.interface';
import { DashboardApiService } from '../../../../../_services/dashboard-api-service/dashboard-api.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DashboardWidgetBaseComponent } from '../dashboard-widget-base.component';
import { cardDisplayData, CardsWidgetLabels } from '../../../../../_services/dashboard-api-service/dashboard-utils';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionService } from '../../../../../_services/subscription-service/subscription.service';

@Component({
  selector: 'app-cards-widget',
  imports: [RouterLink, NgClass, NgTemplateOutlet, NgbTooltip],
  templateUrl: './cards-widget.component.html',
  styleUrl: '../../../../../../static/styles/components/cards-widget.scss',
})
export class CardsWidgetComponent extends DashboardWidgetBaseComponent implements OnInit {
  readonly dashboardApiService = inject(DashboardApiService);
  readonly subscriptionService = inject(SubscriptionService);

  protected cardData: CardsWidgetMapped[] = cardDisplayData;
  protected readonly CardsWidgetLabels = CardsWidgetLabels;

  protected currentSubscriptionCardsMax = computed(() => this.subscriptionService.currentSubscriptionCardsMax());

  ngOnInit() {
    this.dashboardApiService.getCardWidgetDetails().subscribe({
      next: (res) => {
        if (res) {
          this.cardData.forEach((d) => {
            if (d.name === CardsWidgetLabels.available) d.details.value = res.available ?? 0;
            if (d.name === CardsWidgetLabels.active) d.details.value = res.active ?? 0;
            if (d.name === CardsWidgetLabels.new) d.details.value = res.new ?? 0;
            if (d.name === CardsWidgetLabels.invites) d.details.value = res.invites ?? 0;
            if (d.name === CardsWidgetLabels.blocked) d.details.value = res.blocked ?? 0;
            if (d.name === CardsWidgetLabels.removed) d.details.value = res.removed ?? 0;
          });
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
